module.exports = __webpack_public_path__ + "static/img/image.46f2c0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image.png
// module id = yCCv
// module chunks = 4